"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castel-volturno": {
    "b480a260": [{
      "hkey": "761045ed",
      "slug": "castel-volturno",
      "name": "Castel Volturno",
      "primary": true,
      "skipSearch": false
    }],
    "cepparule": [{
      "hkey": "761045ed",
      "slug": "castel-volturno",
      "name": "Castel Volturno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "260cf4e9": [{
      "hkey": "761045ed",
      "slug": "castel-volturno",
      "name": "Castel Volturno",
      "primary": true,
      "skipSearch": false
    }],
    "pineta-nuova": [{
      "hkey": "761045ed",
      "slug": "castel-volturno",
      "name": "Castel Volturno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9f7518d8": [{
      "hkey": "92380f84",
      "slug": "pinetamare",
      "name": "Pinetamare",
      "primary": true,
      "skipSearch": false
    }],
    "villaggio-coppola": [{
      "hkey": "92380f84",
      "slug": "pinetamare",
      "name": "Pinetamare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "castel-volturno"
    }],
    "ecc95c48": [{
      "hkey": "92380f84",
      "slug": "pinetamare",
      "name": "Pinetamare",
      "primary": true,
      "skipSearch": false
    }],
    "villaggio-coppola-pinetamare": [{
      "hkey": "92380f84",
      "slug": "pinetamare",
      "name": "Pinetamare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;